import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import {EmployeeReportResponse} from '../_model/request/EmployeeReportRequest';
import {AbsenceReportResponse} from '../_model/request/AbsenceReportRequest';
import { OvertimeReportResponse } from '../_model/request/OvertimeReportRequest';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
    providedIn: 'root'
})
export class ReportService {

    constructor() { }

    public exportAsExcelFile(sheetDataWithNameList: SheetDataWithName[], excelFileName: string): void {
        const workbook: XLSX.WorkBook = this.createWorkBookObject(sheetDataWithNameList);
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, excelFileName);
    }

    /**
     * workbook data type =  { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
     * create worksheet by json data
     * add worksheet to the workbook
     */
    private createWorkBookObject(sheetDataWithNameList: SheetDataWithName[]) {
        const workbook: XLSX.WorkBook = { Sheets: {}, SheetNames: [] };
        sheetDataWithNameList.forEach(sheetDataWithName => {
            const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(sheetDataWithName.data);
            workbook.Sheets[sheetDataWithName.sheetName] = worksheet;
            workbook.SheetNames.push(sheetDataWithName.sheetName);
        });

        return workbook;
    }

    private saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
        FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    }

    public convertEmployeeReportResponseToSheetDataWithName(employeeReportResponse: EmployeeReportResponse): SheetDataWithName[] {
        const sheet1 = new SheetDataWithName(employeeReportResponse.sheet1, employeeReportResponse.sheetNames[0]);
        const sheet2 = new SheetDataWithName(employeeReportResponse.sheet2, employeeReportResponse.sheetNames[1]);
        const sheet3 = new SheetDataWithName(employeeReportResponse.sheet3, employeeReportResponse.sheetNames[2]);
        const result: any[] = [];
        result.push(sheet1);
        result.push(sheet2);
        result.push(sheet3);
        return result;
    }
    public convertAbsenceReportResponseToSheetDataWithName(absenceReportResponse: AbsenceReportResponse): SheetDataWithName[] {
        const sheet1 = new SheetDataWithName(absenceReportResponse.sheet1, absenceReportResponse.sheetNames[0]);
        const result: any[] = [];
        result.push(sheet1);
        return result;
    }
    public convertOvertimeReportResponseToSheetDataWithName(overtimeReportResponse: OvertimeReportResponse): SheetDataWithName[] {
        const sheet1 = new SheetDataWithName(overtimeReportResponse.sheet1, overtimeReportResponse.sheetNames[0]);
        const result: any[] = [];
        result.push(sheet1);
        return result;
    }
}

export class SheetDataWithName {
    data: any[];
    sheetName: string;

    constructor(data: any[], sheetName: string) {
        this.data = data;
        this.sheetName = sheetName;
    }
}
